import React from "react";
import Reveal from "./Reveal";
import { carpetArea } from "../mock";

const CarpetArea = () => {
  return (
    <section className="bg-neg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-center">
            <h2 className="font-display text-neg-navy text-4xl sm:text-5xl text-center">
              {carpetArea.title}
            </h2>
            <span className="mt-5 h-px w-16 bg-neg-gold" />
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 overflow-x-auto">
            <table className="w-full border-collapse min-w-[560px]">
              <thead>
                <tr className="bg-neg-green text-neg-cream">
                  {carpetArea.headers.map((h) => (
                    <th
                      key={h}
                      className="text-left px-5 py-4 text-xs sm:text-sm font-medium tracking-wide uppercase"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {carpetArea.rows.map((row, i) => (
                  <tr
                    key={i}
                    className={`transition-colors duration-300 hover:bg-neg-beige/60 ${
                      i % 2 === 0 ? "bg-white" : "bg-neg-beige/30"
                    }`}
                  >
                    {row.map((cell, j) => (
                      <td
                        key={j}
                        className={`px-5 py-4 text-sm sm:text-base border-b border-neg-gold/20 ${
                          j === 0 ? "text-neg-navy font-medium" : "text-neg-navy/70"
                        }`}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CarpetArea;
